import { defineMessages } from 'react-intl';
const languages = {
  en: require('../i18n/en.json'),
  es: require('../i18n/es.json'),
};
//English by default
export default defineMessages(languages['en']);
